import { createUrl } from '../helpers/createUrl';
import { getPathnameFromHref } from '../helpers/getPathnameFromHref';
import type { ValidHref } from '../types';

export type UnauthenticatedLinkParams =
  /**
   * Unauthenticated Page
   * /unauthenticated
   */
  {
    page: 'unauthenticated';
    redirectPath?: string;
  };

export const getLinkForUnauthenticated = (
  params: UnauthenticatedLinkParams
): ValidHref => {
  const pathname: ValidHref = `/unauthenticated`;
  const searchParams: { redirectPath?: string } = {};

  if ('redirectPath' in params && params.redirectPath) {
    searchParams.redirectPath = params.redirectPath;
  }
  return createUrl({
    pathname,
    searchParams,
  });
};

export const isUnauthenticatedPageType = (href: ValidHref): boolean => {
  const pathname = getPathnameFromHref(href);
  const parts = pathname.split('/');

  if (parts[1] === 'unauthenticated') {
    return true;
  }
  return false;
};
